// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splitter-container {
	position: relative;
	display: flex;
	height: 100%;
}

.pane-container {
	flex-shrink: 1;
	flex-grow: 1;
	overflow: hidden;
}

.runner-container {
	position: absolute;
	background-color: gainsboro;
}

.runner-horizontal {
	cursor: col-resize;
	height: 100%;
}

.runner-vertical {
	cursor: row-resize;
	width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/splitter.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,aAAa;CACb,YAAY;AACb;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ","sourcesContent":[".splitter-container {\n\tposition: relative;\n\tdisplay: flex;\n\theight: 100%;\n}\n\n.pane-container {\n\tflex-shrink: 1;\n\tflex-grow: 1;\n\toverflow: hidden;\n}\n\n.runner-container {\n\tposition: absolute;\n\tbackground-color: gainsboro;\n}\n\n.runner-horizontal {\n\tcursor: col-resize;\n\theight: 100%;\n}\n\n.runner-vertical {\n\tcursor: row-resize;\n\twidth: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
